function setEventListeners ( ) 
{
    startAccordian( );

    window.addEventListener('resize', function ( ) {
        var currentWidth = window.innerWidth;
        if ( currentWidth > 769 )
        {
            var blogs = document.querySelectorAll( '.toc-blogs-container' );
            blogs.forEach( blog =>
            {
                blog.style.maxHeight = blog.scrollHeight + "px";
            });
        }
        else
        {
            var blogs = document.querySelectorAll( '.toc-blogs-container' );
            blogs.forEach( blog =>
            {
                blog.style.maxHeight = null;
            });
            var arrows = document.querySelectorAll( '.toc-arrow' );
            arrows.forEach( arrow =>
            {
                arrow.classList.remove( "active" );
            });
        }
    });
}

function startAccordian ( )
{
    var header = document.getElementsByClassName( 'toc-header' );
    if ( header )
    {
        for ( var i = 0; i < header.length; i++ )
        {
            header[ i ].addEventListener( "click", function( ) 
            {
                var blogs = this.nextElementSibling;
                var arrow = this.querySelector( '.toc-arrow' );
                if ( blogs.style.maxHeight )
                {
                    blogs.style.maxHeight = null;
                    arrow.classList.toggle( 'active' );
                }
                else
                {
                    blogs.style.maxHeight = blogs.scrollHeight + "px";
                    arrow.classList.toggle( 'active' );
                }   
            });
        }
    }
}

setEventListeners( );